export const CategoriesOptions = {
  Grocery: 1,
  HousingExpense: 2,
  Meals: 3,
  Miscellaneous: 4,
  PerDiem: 5,
  QualityServicesEducation:6,
  Trasportation:7,  
};

export const DescriptionOptions = {
  Other:21,
  MiscellaneousMedicalOrLabWork:41,
};

export const CategoryDescriptionOptions = {
  HousingExpenseHotel: 8,
  MiscellaneousAllotment: 18,
  PerDiemCar: 23,
  PerDiemHousingAmenities: 24,
  PerDiemMeal: 25,
  TrasportationFerry:60,
  TrasportationParking:63,
  TrasportationTaxi:65,
  TrasportationToll:66,
  MiscellaneousOther:21,
  CarAllowance: 70,
  MiscellaneousShiftCompletionBonus: 71,
  MiscellaneousMealAllowance: 72,
  MiscellaneousCarAllowance: 73,
  MiscellaneousCellPhoneStipend: 74,
  PerDiemCellPhoneStipend: 75,
  QualityServicesLicense:41,
  QualityServicesMiscellaneousMedical:42,
};

export const isMiscellaneousCellPhoneStipend = (categoryId: number, categoryDescriptionId: number): boolean => {
  return categoryId === CategoriesOptions.Miscellaneous && 
  categoryDescriptionId === CategoryDescriptionOptions.MiscellaneousCellPhoneStipend;
};

export const isTransportationCarAllowance = (categoryId: number, categoryDescriptionId: number): boolean => {
  return categoryId === CategoriesOptions.Trasportation && 
  categoryDescriptionId === CategoryDescriptionOptions.CarAllowance;
};

export const isCategoryDescriptionFrequencyDefaultPerShift = reimbursementCategoryDescriptionId => {
  return [    
    CategoryDescriptionOptions.MiscellaneousShiftCompletionBonus,
    CategoryDescriptionOptions.MiscellaneousMealAllowance,
    CategoryDescriptionOptions.MiscellaneousCarAllowance,
    CategoryDescriptionOptions.MiscellaneousCellPhoneStipend,
  ].includes(reimbursementCategoryDescriptionId);
};

export const isCategoryDescriptionFrequencyDefaultDaily = reimbursementCategoryDescriptionId => {
  return [CategoryDescriptionOptions.PerDiemMeal, CategoryDescriptionOptions.PerDiemCellPhoneStipend].includes(
    reimbursementCategoryDescriptionId,
  );
};

export const isCategoryDescriptionPayableDefaultTraveler = reimbursementCategoryDescriptionId => {
  return [
    CategoryDescriptionOptions.MiscellaneousShiftCompletionBonus,
    CategoryDescriptionOptions.MiscellaneousMealAllowance,
    CategoryDescriptionOptions.MiscellaneousCarAllowance,
    CategoryDescriptionOptions.MiscellaneousCellPhoneStipend,
    CategoryDescriptionOptions.PerDiemCellPhoneStipend,
  ].includes(reimbursementCategoryDescriptionId);
};

  export const isCategoryDescriptionReceiptPayDefaultTrue = reimbursementCategoryDescriptionId => {
    return ![CategoryDescriptionOptions.HousingExpenseHotel, 
      CategoryDescriptionOptions.PerDiemCar,
      CategoryDescriptionOptions.PerDiemHousingAmenities,
      CategoryDescriptionOptions.PerDiemMeal,
      CategoryDescriptionOptions.TrasportationFerry,
      CategoryDescriptionOptions.TrasportationParking,
      CategoryDescriptionOptions.TrasportationTaxi,
      CategoryDescriptionOptions.TrasportationToll,
      CategoryDescriptionOptions.MiscellaneousCellPhoneStipend,
      CategoryDescriptionOptions.MiscellaneousCarAllowance,
      CategoryDescriptionOptions.MiscellaneousMealAllowance,
      CategoryDescriptionOptions.MiscellaneousShiftCompletionBonus
    ].includes(
      reimbursementCategoryDescriptionId,
    );

};
